import { SelectLabelOption, useSelectLabelOptionsQuery } from 'graphql/types';

const PAGE_COUNT = 100;

type UseCustomLabelOptions = {
  loading: boolean;
  options: SelectLabelOption[];
};
export const useCustomLabelOptions = ({
  labelId,
  queryText
}: {
  labelId?: string;
  queryText: string;
}): UseCustomLabelOptions => {
  const { loading, data } = useSelectLabelOptionsQuery({
    variables: {
      id: labelId ?? '',
      input: { count: PAGE_COUNT, query: queryText }
    },
    skip: !labelId
  });

  return {
    loading,
    options: data?.label?.selectOptions?.items ?? []
  };
};
